import React from "react";
import {Formik, Field, Form} from "formik";
import {TextField, Loading,Select} from "components/form";
import {transformTranslateFromValues} from "lib/helpers";
import Modal from "components/Modal";
import {useCore} from 'store/core'
// components

export default function Report(props) {
   const {show, item} = props;
   //getDirectorYearlyReport

   const core =useCore();
   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{}}
               onSubmit={async (values, {setSubmitting}) => {
                  await core.dispatch(core.getDirectorYearlyReport(props.item.id,values.from,values.to))
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-2 md:gap-3">
                           <Field
                              placeholder="از سال"
                              label="از سال :"
                              name="from"
                              component={Select}
                              options={[{'label':'اول(1399)',value:1},
                              {'label':'دوم(1400)',value:2},
                              {'label':'سوم(1401)',value:3},
                              {'label':'چهارم(1402)',value:4},
                              {'label':'پنجم(1403)',value:5},
                              {'label':'شششم(1404)',value:6},
                           ]}
                           />
                           <Field
                              placeholder="تا سال"
                              label="تا سال :"
                              name="to"
                              component={Select}
                              options={[{'label':'اول(1399)',value:1},
                              {'label':'دوم(1400)',value:2},
                              {'label':'سوم(1401)',value:3},
                              {'label':'چهارم(1402)',value:4},
                              {'label':'پنجم(1403)',value:5},
                              {'label':'شششم(1404)',value:6},
                           ]}
                           />
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button
                           className="btn btn-primary w-20"
                           type="submit"
                           disabled={!!(isSubmitting || !dirty)}
                        >
                           {" "}
                           {isSubmitting ? <Loading/> : "دریافت"}
                        </button>
                        <button
                           type="button"
                           disabled={isSubmitting}
                           onClick={props.close}
                           className="btn btn-outline-secondary w-20 mr-1"
                        >
                           بستن
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
